import { CircularProgress, MenuItem, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { formatWarehouseName } from '../../helpers/formatWarehouseName';
import { useDataWarehouses } from '../../hooks/useDataWarehouses';

type WarehouseSelectorProps = {
  value: string | undefined;
  onChange: (warehouseName: string) => void;
  label?: string;
};

export const WarehouseSelector = ({
  value,
  onChange,
  label = 'Data warehouse',
}: WarehouseSelectorProps) => {
  const { warehouses, primaryWarehouse, isLoading, error } =
    useDataWarehouses();

  if (warehouses.length <= 1 && !isLoading && !error) return null;

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (error) {
    return <Alert severity="error">Failed to load warehouses</Alert>;
  }

  return (
    <TextField
      select
      label={label}
      value={value ?? primaryWarehouse?.name ?? ''}
      onChange={e => onChange(e.target.value)}
      fullWidth
      InputLabelProps={{ shrink: true }}
    >
      {warehouses.map(warehouse => (
        <MenuItem key={warehouse.name} value={warehouse.name}>
          {formatWarehouseName(warehouse)}
        </MenuItem>
      ))}
    </TextField>
  );
};
